import { render, staticRenderFns } from "./AnswerTypeMatrixMultipleChoice.vue?vue&type=template&id=3edfcf70&scoped=true"
import script from "./AnswerTypeMatrixMultipleChoice.vue?vue&type=script&lang=js"
export * from "./AnswerTypeMatrixMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeMatrixMultipleChoice.vue?vue&type=style&index=0&id=3edfcf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edfcf70",
  null
  
)

export default component.exports